import { createRouter, createWebHistory } from 'vue-router';
//import HelloWorld1 from '../components/HelloWorld1.vue';
import PrivacyPage from '../components/PrivacyPage.vue';
import DownloadPage from '../components/DownloadPage.vue';
import LoginPage from '../components/LoginPage.vue';
import DisplayPage from '../components/DisplayPage.vue';

const routes = [
  // {
  //   path: '/w',  //动态导入 按需加载
  //   component: () => import('../components/WeChatVisit.vue'),
  // },

  {
    path: '/',
    component: () => import('../components/IndexPage.vue'),
  },

  {
    path: '/privacy-policy',
    component: PrivacyPage,
  },
  {
    path: '/privacy',
    component: PrivacyPage,
  },
  {
    path: '/download',
    component: DownloadPage,
  },
  {
    path: '/third-auth',
    component: LoginPage,
  },
  {
    path: '/display',
    component: DisplayPage,
  },
  {
    path: '/usermanual',
    beforeEnter: (to, from, next) => {
      const filePath = './file/UserManual.pdf';
      //window.open(filePath, '_blank');//从空白页面打开
      window.location.href = filePath;
      //console.log(to.path, from.path)//next('/') 重定向到'/'
      next(false);//已处理导航，中断路由导航
    },
  },

  {
    path: '/:pathMatch(.*)*',
    component: () => import('../components/NotFound.vue'),

  },



// {
//   path: '/other',
//   redirect: () => {
//     window.location.href = 'https://www.baidu.com';
//   }
// },


];

const router = createRouter({
  history: createWebHistory(),
  base: '',
  routes
});



export default router;
